export default __webpack_public_path__ + "static/media/img-wink-color.144bc0ed.svg";